import { useTranslation } from "react-i18next";

export default function TypesSloten() {
  const { t } = useTranslation("slot-cilinder-vervangen");
  const items = t("typesSloten.items", { returnObjects: true }) as Array<{
    nr: string;
    title: string;
    desc: string;
  }>;

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("typesSloten.h2")}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((item) => (
            <div
              key={item.nr}
              className="bg-white border border-brand-border rounded-xl p-5 md:p-6 hover:border-brand-yellow transition-colors"
            >
              <span className="inline-block font-geist-mono font-bold text-xs text-brand-text bg-brand-yellow px-2 py-1 rounded-md mb-3 md:mb-4">
                {item.nr}
              </span>
              <h3 className="font-geist font-bold text-base md:text-lg text-brand-text mb-1.5 md:mb-2">
                {item.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}